import i18n from "@/i18n";

export default [
  {
    path: "/feeLetter",
    name: "FeeLetter",
    component: () => import("@/pages/feeLetter/index.vue"),
    meta: {
      title: i18n.messages[i18n.locale].feeLetter.feeLetter,
      requireAuth: true,
    },
  },
];
